import { observer } from 'mobx-react'
import React from 'react'
import { ProgressBar /* , ListGroup */ } from 'react-bootstrap'
import './styles.scss'

@observer
class LoyaltyProgressBar extends React.Component {
  render() {
    const { tier, isTierConfigMap, progressTier } = this.props
    let sortedTierKeys = []
    let reverseTierKeys = []
    let progressBarPercent = 0
    let progressbarMaxIndex = 0
    if (isTierConfigMap) {
      sortedTierKeys = Object.keys(tier).sort()
      reverseTierKeys = Object.keys(tier).sort().reverse()
      progressBarPercent = (100 / sortedTierKeys.length).toFixed(2)
      progressbarMaxIndex = reverseTierKeys.length - 1
    }
    return (
      <>
        {isTierConfigMap ? (
          <div className="loyalty-progressbar-container d-flex flex-column align-items-center align-items-md-end py-2">
            <div className="progressbar-types d-flex text-center">
              {sortedTierKeys.map(key => {
                const tierData = tier[key]
                return <h6>{tierData.displayName}</h6>
              })}
            </div>
            <ProgressBar className="loyalty-progressbar border">
              {sortedTierKeys.map(key => {
                const tierData = tier[key]
                let variantTier = 'white'
                let classNameTier = 'text-dark border-right'
                let index
                if (progressbarMaxIndex === 0) {
                  classNameTier = 'text-dark'
                }
                for (index = 0; index <= progressbarMaxIndex; index++) {
                  if (reverseTierKeys[index] === progressTier) {
                    variantTier = ''
                    classNameTier = 'border-right'
                    if (progressbarMaxIndex === 0) {
                      classNameTier = null
                    }
                  }
                }
                progressbarMaxIndex = progressbarMaxIndex - 1

                return (
                  <ProgressBar
                    variant={variantTier}
                    now={progressBarPercent}
                    label={tierData.displayPercentage}
                    className={classNameTier}
                  />
                )
              })}
            </ProgressBar>
          </div>
        ) : (
          <div className="loyalty-progressbar-container d-flex flex-column align-items-center align-items-md-end py-2">
            <div className="progressbar-types d-flex text-center">
              <h6>Basic</h6>
              <h6>VIP</h6>
              <h6>Luxe VIP</h6>
            </div>
            <ProgressBar className="loyalty-progressbar border">
              <ProgressBar
                variant={
                  tier === 'Basic-5' ||
                  tier === 'VIP-10' ||
                  tier === 'Luxe-VIP-20'
                    ? ''
                    : 'white'
                }
                now={33.3}
                label={'5%'}
                className={
                  tier === 'Basic-5'
                    ? 'border-right'
                    : 'text-dark border-right bar-bg'
                }
              />
              <ProgressBar
                variant={
                  tier === 'Basic-5' ||
                  tier === 'VIP-10' ||
                  tier === 'Luxe-VIP-20'
                    ? ''
                    : 'white'
                }
                now={33.3}
                label={'10%'}
                className={
                  tier === 'VIP-10'
                    ? 'border-right'
                    : 'text-dark border-right bar-bg'
                }
              />
              <ProgressBar
                variant={
                  tier === 'Basic-5' ||
                  tier === 'VIP-10' ||
                  tier === 'Luxe-VIP-20'
                    ? ''
                    : 'white'
                }
                now={33.3}
                label={'20%'}
                className={tier === 'Luxe-VIP-20' ? null : 'text-dark bar-bg'}
              />
            </ProgressBar>
          </div>
        )}
      </>
    )
  }
}

export default LoyaltyProgressBar
export { LoyaltyProgressBar }
